(function (root) {
  "use strict";

  var STORAGE_KEY = "everdrive-attribution";
  var EXPIRY_MS = 30 * 86400000;

  function isTrackedKey(key) {
    return key === "ref" || key === "aff" || key === "affiliate" ||
      key === "gclid" || key === "fbclid" || key === "ttclid" ||
      key.indexOf("utm_") === 0;
  }

  function parseParams(search) {
    var params = {};
    var query = new URLSearchParams(search || "");

    query.forEach(function (value, key) {
      if (isTrackedKey(key)) {
        params[key] = value;
      }
    });

    return params;
  }

  function decorateUrl(url, params) {
    if (!params || !Object.keys(params).length) {
      return url;
    }

    try {
      var decorated = new URL(url);
      Object.keys(params).forEach(function (key) {
        if (!decorated.searchParams.has(key)) {
          decorated.searchParams.set(key, params[key]);
        }
      });
      return decorated.toString();
    } catch (error) {
      return url;
    }
  }

  if (typeof module !== "undefined") {
    module.exports = { parseParams: parseParams, decorateUrl: decorateUrl };
  }

  if (!root || !root.location || !root.document) {
    return;
  }

  function readStoredParams() {
    try {
      var stored = JSON.parse(root.localStorage.getItem(STORAGE_KEY));
      if (stored && stored.expiresAt > Date.now() && stored.params) {
        return stored.params;
      }
      root.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Storage may be unavailable, so continue with this visit only.
    }
    return {};
  }

  function storeParams(params) {
    try {
      root.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        params: params,
        expiresAt: Date.now() + EXPIRY_MS
      }));
    } catch (error) {
      // Storage may be unavailable, so continue with this visit only.
    }
  }

  // Merge new parameters over the stored set so a later UTM visit
  // does not erase an earlier affiliate referral.
  var stored = readStoredParams();
  var fresh = parseParams(root.location.search);
  var params = Object.assign({}, stored, fresh);
  if (Object.keys(fresh).length) {
    storeParams(params);
  }

  root.EverdriveAttribution = {
    params: params,
    decorate: function (url) {
      return decorateUrl(url, params);
    },
    isReferral: Boolean(params.ref || params.aff || params.affiliate)
  };

  function decorateShopLinks() {
    var links = root.document.querySelectorAll("a[href]");
    Array.prototype.forEach.call(links, function (link) {
      try {
        var u = new URL(link.href);
        if (u.host === root.location.host && /^\/(products|cart|collections)/.test(u.pathname)) {
          link.href = root.EverdriveAttribution.decorate(link.href);
        }
      } catch (error) {
        // Ignore malformed links outside the affiliate flow.
      }
    });
  }

  if (root.document.readyState === "loading") {
    root.document.addEventListener("DOMContentLoaded", decorateShopLinks, { once: true });
  } else {
    decorateShopLinks();
  }
}(typeof window !== "undefined" ? window : null));
